import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ContentService} from "../../_services/content.service";
import {AuthService} from 'src/app/_services/auth.service';

@Component({
    selector: 'app-media-display',
    templateUrl: './media-display.component.html',
    styleUrl: './media-display.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MediaDisplayComponent implements OnChanges {
    maxBars: number | undefined = 100;
    width: string | undefined = '4px';
    @Input() file: any;
    @Input() small: boolean = false;
    @Input() croppable: boolean = false;
    @Output() initiateCrop: EventEmitter<any> = new EventEmitter();
    @Output() viewImage: EventEmitter<null> = new EventEmitter();
    @Output() pauseSlideshow: EventEmitter<boolean> = new EventEmitter();
    @Output() download: EventEmitter<boolean> = new EventEmitter();
    croppableImageTypes: string[] = ['jpeg', 'jpg', 'png', 'blob']
    loading: boolean = false;
    isRaa: boolean = false;
    croppableFileType: boolean = false;
    displayableFileType: boolean = false;
    documentLoadFailed: boolean = false;

    constructor(public contentService: ContentService,
                private authService: AuthService) {
        if (this.small) {
            this.maxBars = undefined;
            this.width = undefined;
        }
        this.authService.getDynamicSettings().then((r): void => {
            this.isRaa = r.is_raa;
        });
    }

    ngOnChanges(): void {
        if (this.file && !this.small) {
            // TODO If you open lightbox and spam move then the image sticks.
            this.contentService.checkMedia(this.file).then((r): void => {
                this.file = r;
            }).catch((e): void => {
                console.error(e);
            });
        }
        this.documentLoadFailed = false;
        this.displayableFileType = this.correctDocumentFileType(this.file.document)
        this.croppableFileType = this.hasFileType(this.file.image, this.croppableImageTypes)
    }

    // The PDF viewer failed with the current presigned URL; fetch a fresh one
    // (mirrors the video checkUrl flow). If that also fails the template falls
    // back to the download tile.
    refreshDocumentUrl(): void {
        this.contentService.checkIfMediaUrlExpired(this.file.document, 'document', this.file.id)
            .then((response): void => {
                if (response && response !== this.file.document) {
                    this.file = {...this.file, document: response};
                } else {
                    this.documentLoadFailed = true;
                }
            }).catch((e): void => {
            console.error(e);
            this.documentLoadFailed = true;
        });
    }

    checkIfSmallBeforePause(): void {
        if (!this.small) {
            this.pauseSlideshow.emit(true);
        }
    }

    checkUrl(url: string, key: 'video', video: HTMLVideoElement): void {
        let that: this = this;

        this.checkIfSmallBeforePause();
        // Check if video already loaded (means s3 hasn't expired)
        if (video.readyState < 3) {
            this.loading = true
            // Check if s3 has expired
            this.contentService.checkIfMediaUrlExpired(url, key, this.file.id).then(function (response): void {
                if (response && response != url) {
                    that.file[key] = response;
                    if (video) {
                        // Set new url then load the video.
                        setTimeout((): void => {
                            video.load();
                            video.addEventListener('canplay', playVideo);
                        }, 50);
                    }
                } else {
                    that.loading = false;
                    console.error('No response received from validity checker')
                }
            }).catch(e => {
                console.error(e)
            });
        }

        function playVideo(): void {
            // Play video once it loads
            video.play()

            // Remove event listener so it doesnt happen every pause -> play
            video.removeEventListener('canplay', playVideo)
            that.loading = false;
        }
    }

    mediaClick(event?: Event): void {
        if (this.small) {
            event?.stopPropagation();
            this.viewImage.emit()
        }
    }

    private correctDocumentFileType(fileURL: string): boolean {
        // Only PDFs are viewable inline; anything else gets the download tile.
        // Match on the URL path's extension, not a substring anywhere in the
        // presigned URL (query params can contain 'pdf' by coincidence).
        return this.hasFileType(fileURL, ['pdf']);
    }

    private hasFileType(fileUrl: string, typeList: string[]): boolean {
        if (!fileUrl) return false;
        let included: boolean = false;
        if (typeof fileUrl == 'string') {

            let extension: string | undefined = fileUrl.split(/[#?]/)[0].split('.').pop()?.trim();
            if (extension) {
                for (let type of typeList) {
                    if (extension.toLowerCase().includes(type)) {
                        included = true;
                    }
                }
            }
        }
        return included
    }
}
